import { render, staticRenderFns } from "./headerParliament.vue?vue&type=template&id=2ffd1b99"
import script from "./headerParliament.vue?vue&type=script&lang=js"
export * from "./headerParliament.vue?vue&type=script&lang=js"
import style0 from "./headerParliament.vue?vue&type=style&index=0&id=2ffd1b99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports